import React from "react";
import CC from "core/ReusableIcons/CC";

import Link from "core/Link";

const CreativeCommonsIcon = () => {
    // We do not want this bubbling up and selecting Basic, for example.
    // User may just want to find out more, not select Basic.
    const onClick = e => {
        e.stopPropagation();
    };

    return (
        <Link
            onClick={onClick}
            styleType="secondary"
            target="_blank"
            title="An explanation of Attribution-NonCommercial-NoDerivs 2.0 Generic (CC BY-NC-ND 2.0)"
            href="https://www.creativecommons.org/licenses/by-nc-nd/2.0/"
        >
            <CC />
        </Link>
    );
};

export default CreativeCommonsIcon;
